import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { getImage, GetImageAction, GetImageSuccess } from 'src/actions/image/get/GetImage.actions';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';
import ProjectTeamMemberCardComponent, { ProjectTeamMemberCardComponentProps } from './ProjectTeamMemberCard.component';

interface DispatchProps {
  getImage(imageName: string): Promise<GetImageAction>;
}

interface State {
  profilePicture?: File;
}

interface Props extends DispatchProps {
  teamMember: ProjectTeamMember;
}

class ProjectTeamMemberCardContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public componentWillMount() {
    if (this.props.teamMember.profilePicture) {
      this.props.getImage(this.props.teamMember.profilePicture.url).then((response: GetImageSuccess) => {
        if (response.type === 'GET_IMAGE_SUCCESS') {
          this.setState({ profilePicture: response.payload });
        }
      });
    }
  }

  public render(): React.ReactNode {
    return (
      <ProjectTeamMemberCardComponent {...this.getComponentProps()} />
    );
  }

  private getComponentProps(): ProjectTeamMemberCardComponentProps {
    return {
      teamMember: this.props.teamMember,
      profilePicture: this.state.profilePicture || undefined,
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getImage: (imageName: string): Promise<GetImageAction> => (
      dispatch(getImage(imageName))
    )
  });

export default connect(null, mapDispatchToProps)(ProjectTeamMemberCardContainer);


// WEBPACK FOOTER //
// ./src/modules/project/partials/team-members/ProjectTeamMemberCard.container.tsx